/* eslint react/prop-types: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../../components/LoginForm/login.scss';
import { checkAuthActionExternal } from '../../actions/authAction';
import './SplashScreen.scss';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      NextComponent: props.NextComponent,
      renderSplash: true,
      redirectTo: props.redirectTo || 'login',
    };
    const { checkAuth } = this.props;
    const { redirectTo } = this.state;
    checkAuth(true, redirectTo);
  }

  componentWillReceiveProps(newprops) {
    this.setState({ renderSplash: !(newprops.auth.statusAuth === 'fetch') });
  }

  render() {
    const { NextComponent, renderSplash } = this.state;
    const { history, match, location } = this.props;
    return (
      <React.Fragment>
        <div className={`SplashScreen ${(renderSplash) ? 'active' : 'noshow'}`}>
          <div className="anibot-large-white" />
        </div>
        <NextComponent history={history} match={match} location={location} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.authReducer,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    checkAuth: (withRedirect = true, to = '/login') => checkAuthActionExternal(withRedirect, to),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
